import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, Send } from 'lucide-react';
export function Hero() {
  const scrollToGallery = () => {
    const gallerySection = document.getElementById('gallery');
    if (gallerySection) {
      gallerySection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex flex-col justify-center items-center text-center px-4 overflow-hidden bg-[#0A0A0A]" data-id="element-74">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#1a1a1a] via-[#0A0A0A] to-[#000000] opacity-80" data-id="element-75" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-76" />

      {/* Gold Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#D4AF37] rounded-full blur-[150px] opacity-10 pointer-events-none" data-id="element-77" />

      <div className="relative z-10 max-w-4xl mx-auto space-y-8" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-79">
          <h1 className="text-6xl md:text-8xl font-bold tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-[#F3E5AB] via-[#D4AF37] to-[#AA8C2C] mb-2" data-id="element-80">
            KKbaby
          </h1>
          <div className="h-1 w-24 mx-auto bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mb-8" data-id="element-81" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-[#F5F0E8] font-light tracking-wide uppercase" data-id="element-82">
          Your Trusted Companion Awaits in Singapore
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed font-light" data-id="element-83">
          汇聚来自世界各地的漂亮女孩，真实认证，无定金，见面满意再付款。
          <br className="hidden md:block" data-id="element-84" />
          让每一次相遇，成为难忘的心动旅程。
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="pt-8" data-id="element-85">
          <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4" data-id="element-86">
            <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="group relative inline-block px-8 py-4 bg-transparent border border-[#E040FB] text-[#E040FB] text-lg tracking-widest uppercase transition-all duration-300 hover:bg-[#E040FB] hover:text-black overflow-hidden" data-id="element-87">
              <span className="relative z-10 font-medium" data-id="element-88">新加坡春风阁</span>
              <div className="absolute inset-0 h-full w-full scale-0 rounded-full transition-all duration-300 group-hover:scale-100 group-hover:bg-[#E040FB]/20" data-id="element-89" />
            </a>
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center gap-3 px-8 py-4 bg-transparent border border-[#29B6F6] text-[#29B6F6] text-lg tracking-widest uppercase transition-all duration-300 hover:bg-[#29B6F6] hover:text-black overflow-hidden" data-id="element-90">
              <Send className="relative z-10 w-5 h-5" data-id="element-91" />
              <span className="relative z-10 font-medium" data-id="element-92">Telegram</span>
              <div className="absolute inset-0 h-full w-full scale-0 rounded-full transition-all duration-300 group-hover:scale-100 group-hover:bg-[#29B6F6]/20" data-id="element-93" />
            </a>
          </div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2" data-id="element-94">
        <ChevronDown className="w-8 h-8 text-[#D4AF37] animate-bounce opacity-50" data-id="element-95" />
      </motion.div>
    </section>;
}